import { BehaviorSubject, Observable } from 'rxjs';

const shouldPreventOpenSearchSubject = new BehaviorSubject<boolean>(false);
const setShouldPreventOpenSearch = (shouldOpenSearch: boolean): void => {
    shouldPreventOpenSearchSubject.next(shouldOpenSearch);
};
export const disableMainHeaderSearch = (): void => {
    setShouldPreventOpenSearch(true);
};
export const enableMainHeaderSearch = (): void => {
    setShouldPreventOpenSearch(false);
};
export const preventOpenSearch$: Observable<boolean> = shouldPreventOpenSearchSubject.asObservable();
